import utilColors from "../../styles/utilColors";

const styles = {
  formControlBox: {
    display: "flex",
    justifyContent: "end",
    mt: "-15px",
    mb: "5px",
  },
  appSelect: { height: "35px" },
  tabList: { mt: "-35px" },
  // Height is a floor only now — IframeViewer's `resizable` takes over from
  // `defaultHeight` once the user drags the bottom-edge handle.
  iframe: (colors) => ({
    background: utilColors(colors).white,
    width: "100%",
  }),
};

export default styles;
